/**
 * Математика краш-раунда: кривая множителя и её обращение.
 *
 * Сервер не рассылает множитель тиками — он рассылает только время старта раунда.
 * Клиент считает текущий множитель этой же формулой локально, поэтому анимация
 * идёт плавно и не зависит от сетевых задержек, а расхождений между игроками нет.
 */
/**
 * Скорость роста подобрана так, чтобы 2.00x достигалось за 6.5 секунды.
 * Менять её на работающем проекте нельзя без пересчёта статистики раундов:
 * распределение точек краша останется тем же, но темп игры изменится.
 */
export const CRASH_GROWTH_RATE_PER_MS = Math.LN2 / 6500;
/** Множитель, с которого начинается раунд. */
export const CRASH_START_MULTIPLIER = 100;
/** Текущий множитель в сотых по времени с момента старта. */
export function multiplierAt(elapsedMs) {
    if (elapsedMs <= 0)
        return CRASH_START_MULTIPLIER;
    const value = Math.floor(100 * Math.exp(CRASH_GROWTH_RATE_PER_MS * elapsedMs));
    return Math.max(CRASH_START_MULTIPLIER, value);
}
/** Сколько миллисекунд нужно, чтобы кривая дошла до множителя. */
export function timeToReach(multiplier) {
    if (multiplier <= CRASH_START_MULTIPLIER)
        return 0;
    return Math.ceil(Math.log(multiplier / 100) / CRASH_GROWTH_RATE_PER_MS);
}
/** Фазы раунда, одинаковые на сервере и в интерфейсе. */
export const CrashPhase = {
    /** Открыто окно ставок, кривая ещё не запущена. */
    Betting: "betting",
    /** Котик бежит, множитель растёт. */
    Running: "running",
    /** Котик упал, идёт пауза перед следующим раундом. */
    Crashed: "crashed",
};
//# sourceMappingURL=crash.js.map